import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import { API } from "../App";
import { Button } from "../components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "../components/ui/card";
import { Badge } from "../components/ui/badge";
import { Briefcase } from "lucide-react";

const MarketplaceInvitePage = () => {
  const { token } = useParams();
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadInvite = async () => {
      try {
        const response = await axios.get(`${API}/marketplace/invite/${token}`);
        setData(response.data);
      } catch (err) {
        setError(err.response?.data?.detail || "Marketplace invite not found");
      }
    };
    loadInvite();
  }, [token]);

  if (error) {
    return <div className="min-h-screen bg-background flex items-center justify-center p-6"><Card className="max-w-xl w-full"><CardContent className="p-8 text-center text-muted-foreground">{error}</CardContent></Card></div>;
  }

  const opportunity = data?.opportunity;
  const invite = data?.invite;

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-6">
      <Card className="max-w-2xl w-full">
        <CardHeader>
          <div className="flex items-center gap-2 text-primary"><Briefcase className="h-5 w-5" /> OMNΛS Marketplace Invite</div>
          <CardTitle>{opportunity?.title || "Loading opportunity..."}</CardTitle>
          <CardDescription>{opportunity?.trade || "General"}{opportunity?.csi_code ? ` • ${opportunity.csi_code}` : ""}</CardDescription>
        </CardHeader>
        {opportunity && (
          <CardContent className="space-y-4">
            <div className="flex flex-wrap gap-2">
              <Badge variant="outline" className="capitalize">{opportunity.visibility?.replaceAll("_", " ")}</Badge>
              <Badge variant="outline" className="capitalize">Invite {invite?.status}</Badge>
            </div>
            {opportunity.description && <p className="text-sm text-muted-foreground">{opportunity.description}</p>}
            {opportunity.scope_of_work && <p className="text-sm">{opportunity.scope_of_work}</p>}
            <div className="text-sm text-muted-foreground">
              {[opportunity.location_text, opportunity.city, opportunity.state].filter(Boolean).join(" • ") || "Location not set"}
            </div>
            <div className="text-sm text-muted-foreground">
              Deadline: {opportunity.response_deadline ? new Date(opportunity.response_deadline).toLocaleString() : "Not set"}
            </div>
            <div className="flex flex-wrap gap-3 pt-4">
              <Button asChild><Link to="/portal/login">Log in to Respond</Link></Button>
              <Button asChild variant="outline"><Link to="/portal/register">Create Contractor Portal Account</Link></Button>
            </div>
            <p className="text-xs text-muted-foreground">After logging in, open the contractor portal's Open Marketplace tab to express interest.</p>
          </CardContent>
        )}
      </Card>
    </div>
  );
};

export default MarketplaceInvitePage;
